module.exports = __webpack_public_path__ + "img/yo-sign.bc1e24bf.svg";